const ADMIN_TYPES = {
    UPDATE_ADMIN_DATA: "UPDATE_ADMIN_DATA",
    UPDATE_ROLE_DATA:"UPDATE_ROLE_DATA",
    UPDATE_NOTIFICATION:"UPDATE_NOTIFICATION",
    CLEAR_ADMIN:"CLEAR_ADMIN",
  };
  
  
  export default ADMIN_TYPES;